import { ICategory, IProductList } from '../models';
import { SIZES_ORDER } from './categories';
import { Dictionary, groupBy } from 'lodash';

export const sortSizes = (size1: string, size2: string) => {
  const s1 = size1.includes('/') ? size1.split('/')[0].trim() : size1;
  const s2 = size2.includes('/') ? size2.split('/')[0].trim() : size2;

  return !Number.isNaN(Number(s1))
    ? Number(s1) > Number(s2)
      ? 1
      : -1
    : SIZES_ORDER[s1] > SIZES_ORDER[s2]
    ? 1
    : -1;
};

export const groupProductsByCategory = (
  products: IProductList[],
  category: ICategory
) => {
  if (products.every(p => !p.category || p.category.length === 0)) {
    return products;
  }
  const { order, filters } = category;
  const { categories = [] } = filters || {};
  const items: (IProductList | ICategory)[] = [];
  const groupped = groupBy(products, ({ category }) => category);

  function addInItemsWithCategory(categoryId: string | number) {
    const cat = categories.find(
      ({ id_category }) => id_category.toString() === categoryId.toString()
    );
    if (cat) {
      items.push(cat);
      items.push(...groupped[categoryId]);
    }
  }

  if (order && order.length > 0) {
    for (const categoryId of order) {
      if (groupped.hasOwnProperty(categoryId)) {
        addInItemsWithCategory(categoryId);
      }
    }
  } else {
    for (const categoryId in groupped) {
      addInItemsWithCategory(categoryId);
    }
  }

  return items;
};
